<template>
    <div>
        <ts-page-title
            :title="$t('driverTransactionSummary.pageTitle')"
            :breadcrumb="[
                { text: $t('home'), href: '/' },
                {
                    text: $t('driverTransactionSummary.pageTitle'),
                    active: true
                }
            ]"
        />

        <ts-panel>
            <ts-loading-banner :loading="loading">
                <ts-panel-wrapper>
                    <div class="tw-flex tw-space-x-4 tw-items-start">
                        <div class="tw-space-y-2" style="width: 250px">
                            <label class="required">{{
                                $t("driverTransactionSummary.dateRange")
                            }}</label>
                            <a-range-picker
                                v-model="model.date_range"
                                :allowClear="false"
                                format="DD-MM-YYYY"
                                valueFormat="DD-MM-YYYY"
                                style="width: 100%"
                            />
                        </div>
                        <div class="tw-space-y-2 tw-w-full">
                            <label>{{
                                $t("driverTransactionSummary.driverName")
                            }}</label>
                            <a-select
                                show-search
                                v-model="model.driver_id"
                                mode="multiple"
                                style="width: 100%"
                                :default-active-first-option="false"
                                :show-arrow="false"
                                :filter-option="false"
                                :not-found-content="null"
                                :placeholder="
                                    $t('driverTransactionSummary.typeToSearch')
                                "
                                @search="handleShopSearch"
                            >
                                <a-select-option
                                    v-for="d in drivers"
                                    :key="d.driver_id"
                                >
                                    {{ d.driver_name }}
                                </a-select-option>
                            </a-select>
                        </div>
                        <ts-button
                            class="tw-mt-5"
                            color="primary"
                            @click.prevent="fetchData"
                            >{{ $t("preview") }}</ts-button
                        >
                        <ts-button
                            class="tw-mt-5"
                            outline
                            color="info"
                            @click.prevent="pdf"
                            >{{ $t("pdf") }}</ts-button
                        >
                    </div>
                </ts-panel-wrapper>
                <hr />
                <ts-panel-wrapper>
                    <TableComponent :resources="resources" />
                </ts-panel-wrapper>
            </ts-loading-banner>
        </ts-panel>

        <!-- preview pdf -->
        <a-modal
            :title="$t('pdf')"
            width="50%"
            v-model="preview_pdf"
            :footer="null"
        >
            <ts-preview-pdf v-model="waiting" :src="src" />
        </a-modal>
    </div>
</template>

<script>
import moment from "moment";
import TableComponent from "./components/driver-transaction-summary-table-component.vue";
import { mapActions } from "vuex";
import { debounce } from "lodash";
export default {
    name: "driverTransactionSummary",
    components: {
        TableComponent
    },
    data() {
        return {
            loading: false,
            preview_pdf: false,
            waiting: false,
            src: "",
            model: {
                date_range: [
                    moment().format("DD-MM-YYYY"),
                    moment().format("DD-MM-YYYY")
                ],
                driver_id: []
            },
            drivers: [],
            resources: []
        };
    },
    created() {
        this.handleShopSearch(null);
        this.fetchData();
    },
    methods: {
        ...mapActions("report/driverTransactionSummary", ["fetch", "toPdf"]),
        ...mapActions("report/formViewModel", ["fetchFormView"]),
        handleShopSearch: debounce(function(value) {
            this.loading = true;
            this.fetchFormView({
                fnName: "driver",
                search_driver: value
            })
                .then(response => {
                    this.drivers = response.data["driver"];
                })
                .finally(() => (this.loading = false));
        }, 500),
        fetchData() {
            this.loading = true;
            this.resources = [];
            this.fetch(this.model)
                .then(response => {
                    this.resources = response.data;
                })
                .catch(error => {
                    this.$notify({ type: "error", text: error.message });
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        pdf() {
            this.preview_pdf = true;
            this.waiting = true;
            this.toPdf(this.model)
                .then(response => {
                    this.src = response.url;
                })
                .catch(() => {
                    this.preview_pdf = false;
                })
                .finally(() => {
                    this.waiting = false;
                });
        }
    }
};
</script>
